<empty-state icon="fa fa-users" [message]="label" />

@if (buttonCLick | hasObservers) {
	<ic-chip-button [active]="true" (click)="buttonCLick.emit()">
		{{ buttonLabel }}
	</ic-chip-button>
}
